import { useState, useEffect } from "react";
import { Avatar } from "antd";
import { Card } from "antd";
import { Star, Quote } from "lucide-react";

const testimonials = [
  {
    name: "Jennifer Liu",
    role: "International Student",
    university: "Stanford MBA",
    content:
      "My Hero mentor helped me navigate the US job market and land my dream role at a tech startup. The guidance was invaluable!",
    rating: 5,
    avatar: "/asian-woman-mba-student.png",
  },
  {
    name: "Ahmed Hassan",
    role: "Mentor (Hero)",
    specialty: "Software Engineering",
    content:
      "Being a Hero on OneGrad has been incredibly rewarding. I've helped 50+ students while earning extra income on my schedule.",
    rating: 5,
    avatar: "/middle-eastern-man-software-engineer.png",
  },
  {
    name: "Maria Santos",
    role: "International Student",
    university: "MIT Computer Science",
    content:
      "My Senior mentor shared real campus insights that helped me choose the perfect program. Worth every penny!",
    rating: 5,
    avatar: "/latina-woman-computer-science-student.png",
  },
];

export function TestimonialsSection() {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % testimonials.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="py-10 md:py-20 bg-muted/30">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center space-y-12">
          <h2 className="text-3xl sm:text-4xl font-bold text-foreground">
            What our community says
          </h2>

          <div className="relative h-64">
            {testimonials.map((testimonial, index) => (
              <Card
                variant="borderless"
                key={index}
                className={`absolute inset-0 transition-all duration-500 ${
                  index === currentIndex
                    ? "opacity-100 transform translate-x-0"
                    : index < currentIndex
                    ? "opacity-0 transform -translate-x-full"
                    : "opacity-0 transform translate-x-full"
                }`}
              >
                <div className="p-2 md:p-4 text-center">
                  <Quote className="h-8 w-8 text-primary mx-auto" />

                  <blockquote className="text-lg text-card-foreground leading-relaxed">
                    "{testimonial.content}"
                  </blockquote>

                  <div className="flex items-center justify-center space-x-1 mb-4">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <Star
                        key={i}
                        className="h-4 w-4 fill-yellow-400 text-yellow-400"
                      />
                    ))}
                  </div>

                  <div className="flex items-center justify-center space-x-4">
                    <Avatar
                      className="h-12 w-12"
                      src={testimonial.avatar || "/placeholder.svg"}
                      alt={testimonial.name}
                    />

                    <div className="text-left">
                      <p className="font-semibold text-card-foreground">
                        {testimonial.name}
                      </p>
                      <p className="text-sm text-muted-foreground">
                        {testimonial.role}
                        {testimonial.university &&
                          ` • ${testimonial.university}`}
                        {testimonial.specialty && ` • ${testimonial.specialty}`}
                      </p>
                    </div>
                  </div>
                </div>
              </Card>
            ))}
          </div>

          {/* Dots Indicator */}
          <div className="flex justify-center space-x-2">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentIndex(index)}
                className={`w-3 h-3 rounded-full transition-colors ${
                  index === currentIndex
                    ? "bg-primary"
                    : "bg-muted-foreground/30"
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
